// id_ID.js
import React from "react";
const id_ID = {
    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
//components
    "XiaDanTiXing":"Peringatan Pembelian",
    "NH_GDDBH_":"Halo, pesanan ini mencakup produk dengan \"harga perkiraan\". Silakan tunggu konfirmasi penawaran dari pelanggan sebelum membayar. Apakah Anda yakin ingin memesan?",
    "QueRenXiaDan":"Konfirmasi Pembelian",
    "WoZaiKanKan":"Saya lihat lagi",
    "XSQBDZ": "Tampilkan semua alamat",
//ChatRoom
    "ZBZCBQFH": "Tidak mendukung emoji untuk sementara",
    "FaSongLianJie": "Kirim tautan",
    "YiChangXiaoXi": "Pesan abnormal",
    "QingShuRu": "Silakan masukkan",
    "FaSong": "Kirim",
//DateSelector
    "DQSJXYKSSJ": "Waktu saat ini kurang dari waktu mulai",
    "DQSJCGJSSJ": "Waktu saat ini melebihi waktu berakhir",
    "QuXiao": "Batal",
    "NianYueRi": "Tahun bulan hari",
    "ShiFen": "Jam menit",
    "QueDing": "Konfirmasi",
    "Nian": "tahun",
    "Yue": "bulan",
    "Ri": "hari",
    "Shi": "jam",
    "Fen": "menit",
//goods-list-card
    "Qi": "mulai",
//goods-promotion
    "1GeCuXiao": "1 promosi",
    "ChaKanZengPin": "Lihat hadiah",
    "JHDJSHS_1T": "Sisa waktu hingga akhir acara: {d} hari {h} jam {m} menit {s} detik",
    "YHGZ_ZPBKD": "Aturan promosi: Hadiah tidak dapat叠加获取",
    "YHGZ_AZZGM": "Aturan promosi: Nikmati promosi sesuai dengan jumlah pembelian akhir",
    "GuanBi": "Tutup",
//group-filtrate
    "QuanBu": "Semua",
    "ZWXGSJ": "Tidak ada data terkait",
    "ZuiDiJia": "Harga terendah",
    "ZuiGaoJia": "Harga tertinggi",
    "LeiXing": "Jenis",
    "PinPai": "Merek",
    "BiaoQian": "Tag",
    "JiaGeQuJian": "Rentang harga",
    "SPMC_GG_BH_": "Nama produk / Spesifikasi / Nomor / Huruf awal",
    "ZuHeShaiXuan": "Penyaringan kombinasi",
    "ChongZhi_CanShu": "Reset",
//image-upload
    "ZDKSC1ZTP": "Maksimal dapat mengunggah {num} gambar",
    "ZYXSCTP": "Hanya diizinkan mengunggah gambar",
    "SCTPDXBYXC": "Ukuran gambar yang diunggah tidak boleh melebihi {size}",
    "QBYCFSCTP_": "Jangan mengunggah gambar yang sama berulang kali, atau pastikan nama gambar unik",
    "ShangChuanChengGong": "Unggah berhasil",
    "ZDKSC1Z": "Maksimal dapat mengunggah {num} buah",
//keyboard
    "CCSLZDXZ": "Melebihi batasan jumlah maksimum",
    "QiDingLiang": "Jumlah minimum pemesanan",
    "ShouQi": "Sembunyikan",
    "ShanChu": "Hapus",
//MultiPicker
    "FanHui": "Kembali",
//order-cart
    "Dai": "Menunggu",
    "YiQuXiao": "Sudah dibatalkan",
    "ZengPin": "Hadiah",
    "1Zhong": "{num} jenis",
    "1Jian": "1 item",
    "HeJi": "Jumlah",
    "DaiFu": "Menunggu pembayaran",
//order-promotion
    "_DDM1YZ1J_": "【Pesanan满{targetPrice}元赠{presentNum}件】",
    "_DDM1YLJ1Y_": "【Pesanan满{targetPrice}元立减{price}元】",
    "_DDM1YLX1Z_": "【Pesanan满{targetPrice}元立享{discount}折】",
    "DingDanCuXiao": "Promosi pesanan",
//page-ad
    "DLCKJG": "Masuk untuk melihat harga",
//page-floating
    "DianPuZhuYe": "Halaman utama toko",
    "GouWuChe": "Keranjang belanja",
    "ZaiXianKeFu": "Layanan pelanggan online",
    "GeRenZhongXin": "Pusat pribadi",
    "LianXiDianHua": "Nomor telepon kontak",
    "FanHuiDingBu": "Kembali ke atas",
//page-null
    "ZBDYML": "Halaman tidak ditemukan",
    "KNWZCW_HZY": "Mungkin alamat URL salah, atau halaman telah dihapus",
    "FanHuiShangJi": "Kembali ke level atas",
    "FanHuiShouYe": "Kembali ke halaman utama",
//product-edit
    "SPQDBNWK": "Daftar produk tidak boleh kosong",
    "WoZhiDaoLe": "Saya tahu",
    "SFQRSCSP": "Apakah Anda yakin ingin menghapus produk",
    "QueRen": "Konfirmasi",
    "ZYXSRSZBQB": "Hanya diizinkan memasukkan angka dan tidak lebih dari 2 desimal",
    "ShangPinDanJia": "Harga satuan produk",
    "YSPYJ": "Harga asli produk asli",
    "QSRZDJG": "Silakan masukkan harga yang ditentukan",
    "ShuLiang": "Jumlah",
    "DanWei": "Satuan",
    "DanJia": "Harga satuan",
    "BeiZhu": "Catatan",
    "YiChuShangPin": "Hapus produk",
    "XiuGai": "Edit",
//yunshl
    "TPSLCCYXSZ": "Jumlah gambar melebihi nilai yang diizinkan!",
    "WJBDDY5M_QC": "File tidak boleh lebih dari 5m, silakan pilih kembali",
    "TPSCWC": "Unggah gambar selesai",
//BusinessFilter
    "_DGSLM1JZ1J": "【Jumlah pemesanan满{num}件赠{presentNum}件】",
    "_M1JLXMJ1Y_": "【满{num}件立享每件{price}元】",
    "_DHJJZ1Y_": "【Harga pemesanan turun至{price}元】",
    "_M1JLXMJ1Z_": "【满{num}件立享每件{discount}折】",
    "_YDHJD1Z_": "【Harga pemesanan asli打{discount}折】",
    "YuJi": "Perkiraan",
    "MMYDDR": "Tanggal MM/DD",
    "KaiShiFaHuo": "Mulai pengiriman",
    "_DGSLM1Z1_": "【Jumlah pemesanan满{num}赠{presentNum}】",
    "_M1LXM1Y_": "【满{num}立享每{price}元】",
    "_M1LXM1Z_": "【满{num}立享每{discount}折】",
    "DaiQueRen": "Menunggu konfirmasi",
    "DaiFaHuo": "Menunggu pengiriman",
    "DaiShouHuo": "Menunggu penerimaan",
    "YiWanCheng": "Selesai",
    "DaiFuKuan": "Menunggu pembayaran",
    "YiFuKuan": "Pembayaran selesai",
    "YiZuoFei": "Dibatalkan",
    "DaiShenHe": "Menunggu审核",
    "DaiHeXiao": "Menunggu verifikasi",
    "YiHeXiao": "Telah diverifikasi",
    "XianXiaZhiFu": "Pembayaran offline",
    "ZhiNengDaoZhangShiBie": "Transfer offline (pengenalan pembayaran cerdas)",
    "WeiXinZhiFu": "Pembayaran WeChat",
    "KqZhiFu": "Pembayaran Kuaiqian (mendukung WeChat/Alipay)",
    "ZFBZF": "Pembayaran Alipay",
    "YuEZhiFu": "Pembayaran saldo",
    "HuoDaoFuKuan": "Pembayaran COD",
    "DaiTuiHuo": "Menunggu pengembalian barang",
    "DaiTuiKuan": "Menunggu pengembalian dana",
    "ChuangJianDingDan": "Buat pesanan",
    "BianJiDingDan": "Edit pesanan",
    "TiJiaoDingDan": "Kirim pesanan",
    "DingDanShenHe": "审核 pesanan",
    "CaiWuShenHe": "审核 keuangan",
    "BoHui": "Ditolak",
    "TianJiaShouKuan": "Tambahkan penerimaan",
    "ZaiXianZhiFu": "Pembayaran online (mendukung WeChat/Alipay/Pay京东/云闪付)",
    "YinLianZhiFu": "Pembayaran UnionPay",
    "MercadoPagoZhiFu": "Pembayaran MercadoPago",
    "ShouKuanShenHe": "审核 penerimaan",
    "ShouKuanZuoFei": "Penerimaan dibatalkan",
    "ChuKu": "Keluar gudang",
    "ChuKuShenHe": "审核 keluar gudang",
    "FaHuo": "Kirim",
    "TianJiaWuLiu": "Tambahkan logistik",
    "XiuGaiWuLiu": "Edit logistik",
    "ChuKuZuoFei": "Keluar gudang dibatalkan",
    "ShouHuo": "Terima",
    "DingDanHeZhun": "Persetujuan pesanan",
    "QuXiaoDingDan": "Batalkan pesanan",
    "CJTHD": "Buat pesanan pengembalian",
    "DaYin": "Cetak",
    "DaoChu": "Export",
    "DingDanWanCheng": "Pesanan selesai ",
    "QiangZhiWanCheng": "Selesai secara paksa",
    "DingDanZuoFei": "Pesanan dibatalkan",
    "MaiZeng": "Beli dan dapatkan hadiah",
    "ZhiJiang": "Potongan langsung",
    "DaZhe": "Diskon",
    "YuShou": "Pre-order",
    "DingDanManZeng": "Pesanan满赠",
    "DingDanManJian": "Pesanan满减",
    "DingDanManZhe": "Pesanan满折",
    "XinRenQuan": "Kupon baru",
    "ManJianQuan": "Kupon满减",
    "ShangPinQuan": "Kupon produk",
    "DaiJieSuan": "Menunggu penyelesaian",
    "YiJieSuan": "Penyelesaian selesai",
    "QuanBuShangPin": "Semua produk",
    "TuiJianShangPin": "Produk rekomendasi",
    "XinPin": "Produk baru",
    "ReXiaoShangPin": "Produk populer",
    "ChangYongShangPin": "Produk umum digunakan",
//BusinessUtil
    "DaiShouKuan": "Menunggu penerimaan",
    "BuFenShouKuan": "Penerimaan sebagian",
    "YiShouKuan": "Penerimaan selesai",
    "BXYFP": "Tidak perlu faktur",
    "ZZSPTFP": "Faktur pajak umum",
    "ZZSZYFP": "Faktur pajak khusus",
    "QiTaFaPiao": "Faktur lainnya",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Deposit",
    "XianXiaZhuangZhang": "Transfer offline",
    "XianShangZhiFu": "Pembayaran online",
    "YCKZF": "Pembayaran deposit",
    "DaiTiJiao": "Menunggu pengiriman",
    "KuaiDi": "Kirim cepat",
    "SongHuoShangMen": "Pengiriman ke rumah",
    "ShangMenZiQu": "Ambil sendiri",
    "WuLiuHuoYun": "Logistik pengiriman",
    "QiTa": "Lainnya",
//check-util
    "QSRBXY6WDM": "Silakan masukkan kata sandi dengan panjang tidak kurang dari 6 karakter",
    "QSRBDY20WDM": "Silakan masukkan kata sandi dengan panjang tidak lebih dari 20 karakter",
    "MMGSCW": "Format kata sandi salah",
//common-utils
    "SJCW_QLXKF": "Kesalahan data, silakan hubungi layanan pelanggan",
    "ZBZCQD": "Tidak mendukung check-in untuk sementara",
    "HuJiao": "Panggil",
    "DLZHBCZ": "Akun login tidak ada",
    "QLXGLYKT": "Silakan hubungi administrator untuk membuka",
    "GQYZHBJY": "Akun perusahaan ini telah dinonaktifkan",
    "QLXYSDH": "Silakan hubungi 云上订货",
    "GQYZHSYQJS": "Masa percobaan akun perusahaan ini telah berakhir",
    "GQYZHYGQL": "Akun perusahaan ini telah kedaluwarsa",
    "XYXFCNSY": "Perlu diperbarui untuk digunakan",
    "GQYBCZCZH": "Perusahaan ini tidak memiliki akun ini",
    "NDDHZHYBQY": "Akun pemesanan Anda telah dinonaktifkan oleh perusahaan 1, tidak dapat login. Silakan hubungi administrator",
    "NYBSQY1DHZ": "Anda bukan lagi pelanggan kerja sama perusahaan 1, tidak dapat login. Silakan hubungi administrator",
    "NDDPYBTY_B": "Toko Anda telah dinonaktifkan, tidak dapat login. Silakan hubungi administrator",
    "GZHWKTDSZB": "Akun ini tidak membuka fitur khusus lampu. Silakan hubungi administrator",
    "WXSQYZYGQ": "Verifikasi otorisasi WeChat telah kedaluwarsa",
    "WXSQSB": "Gagal otorisasi WeChat",
    "WXSQSB_CWX": "Gagal otorisasi WeChat, informasi kesalahan",
    "DengLuGuoQi": "Login kedaluwarsa",
    "DLGQ_QCXDL": "Login kedaluwarsa, silakan login kembali",
//data-constant
    "ShangJia": "Diunggah",
    "YiXiaJia": "Telah diunduh",
    "YiJinYong": "Telah dinonaktifkan",
    "YiQiYong": "Telah diaktifkan",
    "YiTingYong": "Telah dihentikan",
    "KeHuZhuCe": "Registrasi pelanggan",
    "XinZengDaoRu": "Tambah import",
    "DDDSH": "Menunggu审核 pesanan",
    "DCWSH": "Menunggu审核 keuangan",
    "DaiChuKu": "Menunggu keluar gudang",
    "DCK_BF_": "Menunggu keluar gudang (sebagian)",
    "DFH_BF_": "Menunggu pengiriman (sebagian)",
    "DSH_BF_": "Menunggu penerimaan (sebagian)",
    "DSK_BF_": "Menunggu penerimaan (sebagian)",
    "WTHSQ": "Tidak ada permintaan pengembalian",
    "THDSH": "Pengembalian menunggu审核",
    "THCLZ": "Pengembalian sedang diproses",
    "THYWC": "Pengembalian selesai",
    "DYDHD": "Cetak pesanan pemesanan",
    "DYFHD": "Cetak pesanan pengiriman",
    "DCDHD": "Export pesanan pemesanan",
    "DCFHDWE_P": "Export pesanan pengiriman sebagai file Excel/PDF",
    "TuiDanZuoFei": "Pesanan pengembalian dibatalkan",
    "DTHSH": "Menunggu审核 pengembalian",
    "DaiRuKu": "Menunggu masuk gudang",
    "DRK_BF_": "Menunggu masuk gudang (sebagian)",
    "DFK_BF_": "Menunggu pembayaran (sebagian)",
    "ChuangJianTuiDan": "Buat pesanan pengembalian",
    "BianJiTuiDan": "Edit pesanan pengembalian",
    "TiJiaoTuiDan": "Kirim pesanan pengembalian",
    "TuiHuoShenHe": "审核 pengembalian",
    "RuKu": "Masuk gudang",
    "RuKuShenHe": "审核 masuk gudang",
    "RuKuZuoFei": "Masuk gudang dibatalkan",
    "TianJiaFuKuan": "Tambahkan pembayaran",
    "FuKuanZuoFei": "Pembayaran dibatalkan",
    "FuKuanShenHe": "审核 pembayaran",
    "TuiDanWanCheng": "Pesanan pengembalian selesai",
    "QiTaChuKu": "Keluar gudang lainnya",
    "XiaoShouChuKu": "Keluar gudang penjualan",
    "PanKuiChuKu": "Keluar gudang kerugian",
    "DiaoBoChuKu": "Keluar gudang transfer",
    "CaiGouTuiHuo": "Pengembalian pembelian",
    "TuiHuoRuKu": "Masuk gudang pengembalian",
    "CaiGouRuKu": "Masuk gudang pembelian",
    "QiTaRuKu": "Masuk gudang lainnya",
    "PanYingRuKu": "Masuk gudang keuntungan",
    "DiaoBoRuKu": "Masuk gudang transfer",
    "CJCGD": "Buat pesanan pembelian",
    "BJCGD": "Edit pesanan pembelian",
    "TJCGD": "Kirim pesanan pembelian",
    "CGDZF": "Pesanan pembelian dibatalkan",
    "CGDWC": "Pesanan pembelian selesai",
    "CGTHZF": "Pengembalian pembelian dibatalkan",
    "CGTHWC": "Pengembalian pembelian selesai",
    "THDDY": "Cetak pesanan pengembalian",
    "THDDC": "Export pesanan pengembalian",
    "CKDDY": "Cetak pesanan keluar gudang",
    "CKDDC": "Export pesanan keluar gudang",
    "GLDZH": "Akun admin",
    "DHDZH": "Akun pemesanan",
    "ShenHeTongGuo": "审核 diterima",
    "SHBTG": "审核 ditolak",
    "WuXuFaPiao": "Tidak perlu faktur",
    "DaiKeXiaDan": "Pemesanan atas nama pelanggan",
    "ZiZhuXiaDan": "Pemesanan mandiri",
    "PCShangCheng": "Mall PC",
    "APPShangCheng": "Mall APP",
    "TVShangCheng": "Mall TV",
    "WeiXinShangCheng": "Mall WeChat",
    "ShouJiShangCheng": "Mall ponsel",
    "ADDXSMLTC": "Komisi berdasarkan keuntungan kotor penjualan pesanan",
    "ADDXSSRTC": "Komisi berdasarkan pendapatan penjualan pesanan",
    "AKHSSYG": "Berdasarkan karyawan yang menangani pelanggan",
    "AnZhiDanRen": "Berdasarkan pembuat dokumen",
    "ATHJEBLKCT": "Deduksi jumlah komisi berdasarkan persentase jumlah pengembalian",
    "DDYTHBJXTC": "Pesanan dengan pengembalian tidak mendapatkan komisi",
    "DaiDaKuan": "Menunggu pembayaran",
    "WeiKaiShi": "Belum dimulai",
    "JinXingZhong": "Sedang berlangsung",
    "YiGuoQi": "Telah kedaluwarsa",
//Utils.js
    "YouHuo": "Tersedia",
    "WuHuo": "Habis",
    "Yi": "100 juta",
    "QianWan": "10 juta",
    "BaiWan": "Juta",
    "Wan": "10 ribu",
    "Sheng1Tian": "Sisa 1 hari",
    "Sheng1XiaoShi": "Sisa 1 jam",
    "Miao": "detik",
    "1Miao": "1 detik",
    "GangGang": "Baru saja",
    "1FenZhongQian": "1 menit yang lalu",
    "1XiaoShiQian": "1 jam yang lalu",
    "1TianQian": "1 hari yang lalu",
    "1GeYueQian": "1 bulan yang lalu",
    "1NianQian": "1 tahun yang lalu",
    "WeiZhiLeiXing": "Jenis tidak dikenal",
//WechatUtil
    "YYGBCDSP_K": "Ada produk bagus, mari lihat",
    "ZanWeiSheZhi": "Belum diatur",
//app
    "HQWXSQXX": "Dapatkan informasi otorisasi WeChat",
//flexible
    "JGJYYDMBQ": "Akan mengatur skala berdasarkan tag meta yang sudah ada",
//index
    "NLJZZ": "Memuat dengan usaha",
//routes
    "ShangPinMingXi": "Detail produk",
    "ShangPinLeiBie": "Kategori produk",
    "QXZFPNR": "Silakan pilih isi faktur",
    "QXZFPLX": "Silakan pilih jenis faktur",
    "QTXFPTT": "Silakan isi judul faktur",
    "FaPiaoTaiTou": "Judul faktur",
    "NSRSBH": "Nomor identifikasi pemajak",
    "FaPiaoNeiRong": "Isi faktur",
    "FaPiaoXinXi": "Informasi faktur",
    "KaiJuFaPiao": "Cetak faktur",
    "FaPiaoLeiXing": "Jenis faktur",
    "Han": "Termasuk",
    "WeiHan": "Tidak termasuk",
    "Shui": "Pajak",
    "QSRFPTT": "Silakan masukkan judul faktur",
    "QSRNSRSBH": "Silakan masukkan nomor identifikasi pemajak",
//routes
//cart-bill
    "YiManZu_Man": "Sudah memenuhi【满",
    "ZaiGou": "Beli lagi",
    "YMZ_DHJJZ": "Sudah memenuhi【Harga pemesanan turun至",
    "JianJiangZhi": "item turun至",
    "YMZ_YDHJD": "Sudah memenuhi【Harga pemesanan asli打",
    "JianMeiJian": "item per item",
    "SYTCSLW0_WFJRGWC": "Sisa jumlah paket adalah 0, tidak dapat ditambahkan ke keranjang",
    "QingXuanXeShangPin": "Silakan pilih produk!",
    "GSPYXJ": "Produk ini telah diunduh!",
    "ZJ2TN": "Dalam 2 hari terakhir",
    "QDQCXJSP": "Yakin ingin menghapus produk yang diunduh?",
    "QingChuChengGong": "Hapus berhasil",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Produk paket tidak dapat ditambahkan ke keranjang, silakan hapus produk paket terlebih dahulu sebelum memindahkan ke keranjang!",
    "SPSLBN": "Jumlah produk tidak bisa",
    "TaoCanHan": "Paket termasuk",
    "TaoCan": "Paket",
    "QHDSL": "Silakan cek jumlah",
    "SPSLBNDY": "Jumlah produk tidak boleh kurang dari",
    "XianDingLiang": "Jumlah terbatas",
    "YiRuShouCang": "Tambahkan ke favorit",
    "QuanXuan": "Pilih semua",
    "JianZeng": "item hadiah",
    "JianLiXiang_Man": "item mendapatkan【满",
    "Yuan_": "yuan】",
    "Zhe_": "diskon】",
    "KCBZ_WFJRGWC": "Stok tidak cukup, tidak dapat ditambahkan ke keranjang",
    "XDJEDYDY": "Jumlah pembelian lebih besar atau sama dengan",
    "WYXJHYSXDSP": "Tidak ada produk yang diunduh atau tidak berlaku!",
    "DYQDL": "Kurang dari jumlah minimum pemesanan",
    "ZSPG1J": "{count} jenis produk, total {number} item",
    "WanCheng": "Selesai",
    "BianJi": "Edit",
    "You": "Ada",
    "ZSPBFHYQ_W": "jenis produk tidak memenuhi syarat, tidak dipilih, klik untuk melihat alamat default",
    "SPSLBNGY": "Jumlah produk tidak boleh lebih dari",
    "JXDJ_CKXYGBFHYQSP": "Klik terus, lihat produk berikutnya yang tidak memenuhi syarat",
    "XiaDan": "Pesan",
    "JianJiang": "item potong",
    "QRYCSP": "Yakin ingin menghapus produk?",
    "QXZXDSP": "Silakan pilih produk yang akan dipesan",
    "KCBZ_QCXXZ": "Stok tidak cukup, silakan pilih kembali!",
    "KuCun": "Stok",
    "YCKXD": "yuan untuk dapat memesan",
    "QDSCSP": "Yakin ingin menyimpan produk ke favorit?",
    "ShouCangChengGong": "Simpan ke favorit berhasil",
    "GYXDL": "Lebih dari jumlah terbatas",
    "LiSheng": "Hemat langsung",
    "GWCHSKD_QGYGB": "Keranjang masih kosong, ayo berkeliling!",
    "QuGuangGuang": "Berkeliling",
    "QCXJSP": "Hapus produk yang diunduh",
    "ZongE": "Total",
    "YouHui": "Diskon",
//cart-list
    "QXZJHRQ": "Silakan pilih tanggal pengiriman",
    "FuJiaFeiYong": "Biaya tambahan",
    "ZhongShangPin_Gong": "jenis produk, total",
    "PeiSongShiJian": "Waktu pengiriman",
    "QXZPSSJ": "Silakan pilih waktu pengiriman",
    "DingDanJinE": "Jumlah pesanan",
    "SCFJ_ZD4Z": "Unggah lampiran, maksimum {num} lembar, setiap lembar tidak lebih dari {size}",
    "KeYongShangPin": "Produk yang可用",
    "ShiYongShuoMing": "Petunjuk penggunaan",
    "YouXiaoQi": "Masa berlaku",
    "Man": "满",
    "BZZBZCTSFH": "Catatan sementara tidak mendukung simbol khusus",
    "QingXuanZe": "Silakan pilih",
    "KaiPiaoXuJia": "Pencetakan faktur perlu menambah",
    "PeiSongFangShi": "Cara pengiriman",
    "ShangPinZongJia": "Total harga produk",
    "YouHuiQuan": "Kupon diskon",
    "ZhangKeXan": "lembar可选",
    "DDJEWMZ": "Jumlah pesanan tidak memenuhi",
    "WDYHQ": "Kupon saya",
    "KYYHQ": "Kupon可用",
    "YuanKeYong": "yuan可用",
    "ChaKanDingDan": "Lihat pesanan",
    "ShangPinHanShui": "Produk termasuk pajak",
    "SPWHS": "Produk tidak termasuk pajak",
    "GeDian": "titik",
    "QueRenDingDan": "Konfirmasi pesanan",
    "XZSHDZ": "Tambahkan alamat pengiriman",
    "ShangPinQingDan": "Daftar produk",
    "WKYYHQ": "Tidak ada kupon可用",
    "HuChi": "Konflik",
    "DaiJinQuan": "Kupon uang",
    "YunFei": "Biaya pengiriman",
    "ShuiFei": "Biaya pajak",
    "WKYYY": "Alasan tidak可用",
    "YHQYGQ": "Kupon telah kedaluwarsa",
    "WDYHQSYSJ": "Belum waktunya menggunakan kupon",
    "ZDSPJEWMZ": "Jumlah produk tertentu tidak memenuhi",
    "BKYYHQ": "Kupon tidak可用",
    "RMBJE":"Jumlah RMB",
//cart-presale-order
    "QXZPSFS": "Silakan pilih cara pengiriman",
    "1ZSP_G": "1 jenis produk, total",
    "YSSP_YJ": "Produk pre-order, diperkirakan",
    "JiaoHuoRiQi": "Tanggal pengiriman",
    "GMJLY": "Pesan untuk penjual",
//scan-to-cart
    "ZhengZaiChuLi...": "Sedang diproses...",
    "FSCSP": "Produk non-mall",
    "ZZCLTXM": "Sedang memproses kode batang...",
    "SPTJCG": "Produk berhasil ditambahkan",
    "QSTXM": "Silakan pindai kode batang",
    "SFSCDQSP": "Apakah ingin menghapus produk saat ini?",
    "BQ_ZBDXGSP": "Maaf, produk terkait tidak ditemukan",
    "XuanZeDanWei": "Pilih satuan",
    "JRGWC": "Tambahkan ke keranjang",
    "QXXZDJRSP": "Silakan pilih produk yang akan ditambahkan terlebih dahulu",
    "ZhengZaiChuLi": "Sedang diproses",
    "JRGWCCG": "Berhasil menambahkan ke keranjang",
    "ZanWuShangPin": "Tidak ada produk",
//earn-brokerage-share
    "XTYJBNFZSP": "Sistem telah menyalin tautan produk untuk Anda!",
    "NKYHDDYDYJ": "Anda dapat mendapatkan komisi yang sesuai. Komisi dapat dilihat di \"Saya",
    "LiChaKan": "di lihat",
    "WeiXinHaoYou": "Teman WeChat",
    "ErWeiMa": "Kode QR",
    "CASBEWM": "Tekan dan identifikasi kode QR",
    "FZSB_QCXFZ": "Salin gagal, silakan salin kembali!",
    "TWEWM": "Kode QR gambar teks",
    "BCDXC": "Simpan ke album",
    "CATPBCDXC": "Tekan gambar dan simpan ke album",
    "FuZhiLianJie": "Salin tautan",
    "FXZYJ": "Bagikan untuk mendapatkan komisi",
    "YJZGKZQYJ": "Perkiraan maksimum komisi yang dapat diperoleh",
//goods-share
    "FXSPGLSKH": "Bagikan produk ke pelanggan eceran",
    "FXHJSCNZSD": "Setelah dibagikan, akan生成专属的 mobile mall Anda, Anda dapat mengatur harga produk di mall, mengisi kontak Anda, menarik konsumen untuk datang membeli.",
    "WSCDQJG_ND": "Harga saat ini mall mobile: Harga pemesanan Anda ×",
    "DaiSheZhi": "Menunggu pengaturan",
    "PengYouQuan": "Moment",
    "GGFXSZ": "Ubah pengaturan berbagi",
//wechat-login
    "QXSRZH": "Silakan masukkan akun terlebih dahulu",
    "MMGSCW_6_20W": "Format kata sandi salah (6-20 huruf atau angka)",
    "BDYYZH": "Bind akun yang sudah ada",
    "WXKJDL": "Login cepat WeChat",
    "BangDingZhangHao": "Bind akun",
    "YYZH_QDL": "Sudah memiliki akun, pergi login",
    "ZCXZH": "Daftar akun baru",
    "HuanYingNi": "Selamat datang",
    "ZH_SJHM": "Akun/Nomor ponsel",
    "MiMa": "Kata sandi",
    "QDLHCZ": "Silakan login sebelum beroperasi",
//add-to-cart
    "KCBZ_BNTJG": "Stok tidak cukup, tidak dapat menambahkan lebih banyak",
//combined-pay-online
    "ZhiFuChengGong": "Pembayaran berhasil!",
    "ZFSB_QCXCS": "Pembayaran gagal, silakan coba lagi!",
//
    "QXXZGG": "Silakan pilih spesifikasi terlebih dahulu",
    "SXGGX": "Spesifikasi yang dipilih perlu",
    "GMSLXYQDL_": "Jumlah pembelian kurang dari jumlah minimum pemesanan, silakan beli kembali!",
    "GMSLDYXDL_": "Jumlah pembelian lebih dari jumlah terbatas, silakan beli kembali!",
    "ShangPinBianHao": "Nomor produk",
    "QiDing": "Minimum pemesanan",
    "SXGGDGSLBK": "Jumlah pemesanan spesifikasi yang dipilih tidak boleh melebihi",
    "KCBZ_BNTJ": "Stok tidak cukup, tidak dapat ditambahkan",
    "QXXZSP": "Silakan pilih produk terlebih dahulu",
    "SLBNW0": "Jumlah tidak boleh 0",
    "QXZGG": "Silakan pilih spesifikasi",
    "LiJiYuDing": "Pesan sekarang",
//nav
    "ShouYe": "Halaman utama",
    "ShangPin": "Produk",
    "DingDan": "Pesanan",
    "WoDe": "Saya",
//pay-online
    "ZhiFuQuXiao": "Pembayaran dibatalkan",
//account-log
    "ShangPinYongJin": "Komisi produk",
    "YaoQingJiangLi": "Hadiah undangan",
    "TiXian": "Tarik tunai",
    "TiXianBoHui": "Penarikan ditolak",
    "ZhuanWeiYuE": "Konversi ke saldo",
    "Jin7Tian": "7 hari terakhir",
    "Jin30Tian": "30 hari terakhir",
    "ShouZhiMingXi": "Detail pendapatan dan pengeluaran",
    "ZanWuShuJu": "Tidak ada data",
//client-statistics
    "WoDeKeHu": "Pelanggan saya",
    "WoDeYaoQing": "Undangan saya",
//distribution-home
    "LeiJiKeHu": "Total pelanggan",
    "LeiJiDingDan": "Total pesanan",
    "YaoQingHaoYou": "Undang teman",
    "LeiJiYaoQing": "Total undangan",
    "LJSY_Y_": "Total pendapatan (yuan)",
    "BHDJS": "Termasuk menunggu penyelesaian",
    "J7TSY_Y_": "Pendapatan 7 hari terakhir (yuan)",
    "J7TXZKH_R_": "Pelanggan baru 7 hari terakhir (orang)",
    "KTXYJ": "Komisi yang dapat ditarik",
    "XYJYO": "Perlu berusaha lebih!",
    "ChangJianWenTi": "Pertanyaan umum",
    "Q_ZMYJX_TG": "Q：Bagaimana cara \"promosikan untuk mendapatkan uang",
    "A_FXDPND_Z_": "A：Bagikan tautan halaman dengan ikon \"赚\" di toko, menarik teman untuk mengklik, teman mendaftar (hubungan pelanggan diatur sebagai terikat saat pendaftaran) atau memesan (hubungan pelanggan diatur sebagai terikat saat pemesanan) dan membeli produk dengan ikon \"赚\" di toko tersebut, akan dihitung sebagai pendapatan \"promosikan untuk mendapatkan uang\" sesuai dengan metode perhitungan tertentu.",
    "Q_RHJS_TGZ": "Q：Bagaimana menghitung pendapatan \"promosikan untuk mendapatkan uang\"?",
    "A_MGD_Z_TBD": "A：Setiap produk dengan ikon \"赚\" memiliki persentase komisi tertentu, yang tidak memiliki tanda tersebut menunjukkan bahwa produk tidak berpartisipasi dalam \"promosikan untuk mendapatkan uang\". Setelah teman berhasil membayar melalui tautan berbagi Anda, komisi akan dihitung secara terpisah berdasarkan persentase komisi setiap produk dalam pesanan (komisi yang tidak berpartisipasi dalam promosi adalah 0), dan akhirnya dijumlahkan menjadi pendapatan komisi untuk pesanan tersebut. Dalam perhitungan pendapatan akan dikurangi biaya pengiriman, pengembalian, potongan满减, dll., berdasarkan harga akhir.",
    "Q_TGZQ_DSY": "Q：Kapan pendapatan \"promosikan untuk mendapatkan uang\" akan masuk akun?",
    "A_HYTGNDFX": "A：Setelah teman berhasil membayar melalui tautan berbagi Anda, Anda dapat melihat promosi ini di pesanan promosi pusat penjualan, statusnya adalah menunggu penyelesaian, setelah pelanggan mengkonfirmasi penerimaan, transaksi pesanan selesai diselesaikan, pendapatan ini akan secara otomatis dimasukkan ke akun pribadi Anda,随时可提现.",
    "Q_LJKH_LJY": "Q：Tidak ada avatar dan nama panggilan di daftar total pelanggan dan total undangan?",
    "A_WXYQZYGZ": "A：WeChat mengharuskan hanya关注 akun layanan resmi才能获取 avatar dan nama panggilan, pelanggan toko yang merupakan akun layanan resmi关注 akun resmi toko, yang bukan akun layanan resmi关注 akun \"云上订货\" dan klik halaman detail produk apapun toko即可获取 avatar dan nama panggilan.",
    "Q_WSMWASSG": "Q：Mengapa saya berbagi sesuai aturan di atas, tetapi tidak mendapatkan pendapatan promosi?",
    "A_1_HYKNBW": "A：1、Teman mungkin tidak membangun hubungan pelanggan dengan Anda (teman mengklik tautan penjual lain untuk mendaftar atau memesan) 2、Jika teman membuka tautan berbagi Anda di luar lingkungan WeChat (seperti browser default ponsel), jika browser tidak membuka cookie, juga tidak akan dapat mencatat hubungan pelanggan, yaitu tidak dapat mencatat pesanan promosi 3、Jika semua yang disebutkan di atas tidak masalah tetapi masih tidak ada catatan pesanan promosi, silakan hubungi staf",
//
    "XiaoShouZhongXin": "Pusat penjualan",
//generalize-goods
    "SPMC_GG_BH": "Nama produk / Spesifikasi / Nomor",
    "YuJiZhuan": "Perkiraan penghasilan",
//invitation-home
    "YaoQingKa": "Kartu undangan",
    "YNYQJR_TGY": "Undang Anda untuk bergabung, promosikan dan dapatkan hadiah",
    "DJBCDXC": "Klik untuk menyimpan ke album",
    "JYQKFSGHY_": "Kirim kartu undangan ke teman, promosikan toko untuk mendapatkan imbalan",
//join-home
    "HuanYingJiaRu": "Selamat bergabung",
    "YQNCW": "Undang Anda menjadi",
    "LiJiJiaRu": "Bergabung sekarang",
//order-statistics
    "YuJiYongJin": "Perkiraan komisi",
    "YongJin": "Komisi",
    "YuJiJiangLi": "Perkiraan hadiah",
    "JiangLi": "Hadiah",
    "SPTGDD": "Pesanan promosi produk",
    "YQJLDD": "Pesanan hadiah undangan",
//performance-statistics
    "YeJiTongJi": "Statistik kinerja",
    "LJKH_R_": "Total pelanggan（orang）",
    "SPYJ_Y_": "Komisi produk（yuan）",
    "HanDaiJieSuan": "Termasuk menunggu penyelesaian",
    "XGMCJS": "Penjelasan istilah terkait",
    "KeHu": "Pelanggan",
    "HFXYBDLKHG": "Pembeli atau distributor yang terikat hubungan pelanggan dengan distributor",
    "YaoQing": "Undangan",
    "FXYCGYQDXJ": "Distributor bawah yang berhasil diundang oleh distributor",
    "FXYTJKHGMH": "Komisi yang dapat diperoleh oleh distributor setelah distributor merekomendasikan pelanggan untuk membeli",
    "XJFXYTGSPH": "Hadiah yang diperoleh oleh distributor atas setelah distributor bawah mempromosikan produk",
//posters-promoting
    "NiCheng": "Nama panggilan",
    "HaiBaoTuiGuang": "Promosi poster",
    "JHBFSGHY_T": "Kirim poster ke teman, promosikan toko untuk mendapatkan imbalan",
//settlement-home
    "JieSuanZhongXin": "Pusat penyelesaian",
    "KTXJE": "Jumlah yang dapat ditarik",
    "TiXianJiLu": "Riwayat penarikan",
//withdraw-account
    "KHRXMBNWK": "Nama pemilik akun tidak boleh kosong!",
    "KHHBNWK": "Bank penerbit tidak boleh kosong!",
    "YHKHBNWK": "Nomor kartu bank tidak boleh kosong!",
    "SFZTPBNWK": "Gambar KTP tidak boleh kosong!",
    "YHKTPBNWK": "Gambar kartu bank tidak boleh kosong!",
    "BaoCunChengGong": "Simpan berhasil!",
    "SCSFZ": "Unggah KTP",
    "SCYHK": "Unggah kartu bank",
    "BaoCun": "Simpan",
    "TiXianZhangHu": "Akun penarikan",
    "TS_QTXZSXX": "Peringatan: Silakan isi informasi yang benar, dapat menarik setelah审核通过",
    "KHRXM": "Nama pemilik akun",
    "KaiHuHang": "Bank penerbit",
    "YinhangKaHao": "Nomor kartu bank",
    "QSRZSXM": "Silakan masukkan nama asli",
    "QSRKHHMC": "Silakan masukkan nama bank penerbit",
    "QSRYHKH": "Silakan masukkan nomor kartu bank",
//withdraw-deposit
    "QXSZTXZH": "Silakan设置 akun penarikan terlebih dahulu",
    "QuSheZhi": "Pergi设置",
    "JEXY10Y_BKT": "Jumlah kurang dari 10 yuan, tidak dapat ditarik!",
    "JECGKTXJE": "Jumlah melebihi jumlah yang dapat ditarik!",
    "CGDRKTXSX_": "Melebihi batas penarikan harian, batas penarikan harian adalah 20000 yuan!",
    "QueDingJiang": "Yakin akan",
    "ZhuanDaoYuE": "transfer ke saldo?",
    "1_JEDY10YSB": "1、Jumlah kurang dari 10 yuan tidak dapat ditarik;",
    "2_BCTXDZSJ": "2、Waktu penarikan dana ini adalah dalam 5 hari kerja setelah pengajuan penarikan berhasil, batas penarikan harian adalah 20000 yuan;",
    "3_GBSRWHSS": "3、Pendapatan ini adalah pendapatan sebelum pajak, silakan sendiri melaporkan dan membayar pajak penghasilan pribadi ke instansi pajak terkait!",
    "4_ZDYEKYYS": "4、Transfer ke saldo dapat digunakan untuk berbelanja di mall;",
    "TXSQCG_QDD": "Pengajuan penarikan berhasil, silakan tunggu审核",
    "JEDYKTXJE_": "Jumlah lebih besar dari jumlah yang dapat ditarik, tidak dapat diubah ke saldo!",
    "ZZYECG_QDG": "Transfer ke saldo berhasil, silakan lihat di pusat pribadi!",
    "BenCiTiXian": "Penarikan kali ini",
    "ZhuangDaoYuE": "Transfer ke saldo",
    "TiXianDao": "Tarik ke",
    "JEW0BKZZYE": "Jumlah 0 tidak dapat diubah ke saldo!",
    "DRTXSX2WY": "Batas penarikan harian 20.000 yuan",
    "QuanBuTiXian": "Tarik semua",
    "QueRenTiXian": "Konfirmasi penarikan",
//goods-filter-tab
    "ZuiChangGouMai": "Paling sering dibeli",
    "MoRenPaiXu": "Urutan default",
    "ZongHe": "Gabungan",
    "FenLei": "Kategori",
    "XiaoLiangYouXian": "Prioritas penjualan",
    "XiaoLiang": "Penjualan",
    "JiaGe": "Harga",
    "ShaiXuan": "Penyaringan",
    "ZuiJinGouMai": "Terakhir dibeli",
    "CuXiaoYouXian": "Prioritas promosi",
    "QuanBuFenLei": "Semua kategori",
    "ZhiKanCuXiao": "Hanya lihat promosi",
    "XuanZeFenLei": "Pilih kategori",
    "QXZFL": "Silakan pilih kategori",
//goods-list-default
    "ZWXGSP": "Tidak ada produk terkait",
//goods-brand-list
    "PinPaiHui": "Koleksi merek",
//goods-classify-filter
    "TuiJianFenLei": "Kategori rekomendasi",
    "ShangPinFenLei": "Kategori produk",
    "GengDuo": "Lebih banyak",
//goods-detail
    "DLZHBSDQQY": "Akun login bukan akun pelanggan perusahaan saat ini",
    "GXNHQ": "Selamat Anda mendapatkan",
    "SZWSCJGH_C": "Setelah设置 harga mall mobile, baru dapat dibagikan",
    "JHDJSHS_": "Sisa waktu hingga akhir acara",
    "DLHKFX": "Login untuk berbagi",
    "ZZHQXX_QSH": "Mendapatkan informasi, silakan coba lagi nanti",
    "Zhang": "lembar",
    "Tian": "hari",
    "QXZGGZQPD": "Silakan pilih spesifikasi sebelum memasang lampu!",
    "Yuan": "yuan",
    "XS_F_M": "jam/menit/detik",
//integral
    "WoDeJiFen": "Poin saya",
    "DaBaiLe": "Kalahkan",
    "JiFen": "Poin",
    "DeHuiYuan": "anggota",
    "ZhuanJiFen": "Dapatin poin",
    "JiFenMingXi": "Detail poin",
    "HuanLiPin": "Tukar hadiah",
    "CKGDHL": "Lihat lebih banyak hadiah",
    "ChaDingDan": "Cari pesanan",
//integral-convert
    "DHSLBNCG": "Jumlah penukaran tidak boleh melebihi",
    "DuiHuanShuLiang": "Jumlah penukaran",
    "SuoXuJiFen": "Poin yang dibutuhkan",
//integral-detail
    "LiPinXiangQing": "Detail hadiah",
    "WoYaoDuiHuan": "Saya ingin menukar",
    "ShengYu": "Sisa",
    "TuWenXiangQing": "Detail gambar teks",
    "YiDuiWan": "Sudah habis ditukar",
//integral-filter
    "FenLeiShaiXuan": "Penyaringan kategori",
    "JiFenShaiXuan": "Penyaringan poin",
//integral-flow
    "JiFenShouRu": "Pendapatan poin",
    "JiFenZhiChu": "Pengeluaran poin",
//integral-logistics
    "DingDanGenZong": "Lacak pesanan",
    "WuLiuGongSi": "Perusahaan logistik",
    "WuLiuDanHao": "Nomor resi logistik",
//integral-order
    "DingDanLieBiao": "Daftar pesanan",
    "YiFaHuo": "Telah dikirim",
    "JiFenDingDan": "Pesanan poin",
    "ChaKanWuLiu": "Lihat logistik",
//integral-order-create
    "LPSLBZ_QCX": "Jumlah hadiah tidak cukup, silakan bayar kembali",
    "JiFenBuZu": "Poin tidak cukup",
    "ZhiFuXinXi": "Informasi pembayaran",
    "JiXuGuangGuang": "Lanjut berkeliling",
    "QTXSHXX": "Silakan isi informasi penerimaan",
    "DuiHuanChengGong": "Penukaran berhasil",
    "LPDHQR": "Konfirmasi penukaran hadiah",
    "SCCKJ": "Harga referensi pasar",
    "LiJiZhiFu": "Bayar sekarang",
//integral-order-detail
    "DingDanXiangQing": "Detail pesanan",
    "DingDanZhuangTai": "Status pesanan",
    "DingDanBianHao": "Nomor pesanan",
    "DuiHuanShiJian": "Waktu penukaran",
    "ShouHuoXinXi": "Informasi penerimaan",
    "HuaFeiJiFen": "Poin yang digunakan",
//integral-rule
    "QDZJF": "Check-in untuk mendapatkan poin",
    "XDZJF": "Pesan untuk mendapatkan poin",
    "DDWCHKHDYD": "Setelah pesanan selesai, dapat mendapatkan dengan jumlah pesanan*",
    "1_MRQD_JL": "1、Check-in setiap hari, hadiah",
    "2_LXQD3T_EW": "2、Check-in berturut-turut selama 3 hari, hadiah tambahan",
    "3_LXQD7T_EW": "3、Check-in berturut-turut selama 7 hari, hadiah tambahan",
    "BeiDeJiFen": "kali poin",
    "DLZJF": "Login untuk mendapatkan poin",
    "MeiRiDengLu": "Login setiap hari",
    "SC_JL": "mall, hadiah",
//integral-rule-detail
    "GuiZe": "Aturan",
//integral-sign
    "QianDaoYouLi": "Check-in dengan hadiah",
    "QianDaoGuiZe": "Aturan check-in",
    "YLXQD": "Sudah check-in berturut-turut",
    "QDCG_NYJLX": "Check-in berhasil, Anda telah check-in berturut-turut",
    "QDCG_BCHD": "Check-in berhasil, kali ini mendapatkan",
    "QSRBZ": "Silakan masukkan catatan",
    "DingDanZengPin": "Hadiah pesanan",
    "GuiGeBianHao": "Nomor spesifikasi",
    "GuiGe": "Spesifikasi",
//combined-pay
    "CDDWXFK": "Pesanan ini tidak perlu dibayar",
    "YHYEBZ": "Saldo pengguna tidak cukup!",
    "ZFJEBNW0": "Jumlah pembayaran tidak boleh 0!",
    "ZFJEBNDYDD": "Jumlah pembayaran tidak boleh lebih dari jumlah yang harus dibayar pesanan",
    "DFKJE": "Jumlah yang harus dibayar",
    "FuKuanFangShi": "Cara pembayaran",
    "FuJian": "Lampiran",
    "ZHYFZ": "Akun telah disalin",
    "GHSKZH": "Ganti akun penerimaan",
    "SYXXZFQSCF": "Gunakan pembayaran offline silakan unggah tangkapan layar pembayaran, untuk keuangan memastikan jumlah!",
    "XXZF_BXXZS": "Pembayaran offline, harus memilih akun penerimaan",
    "DingDanZhiFu": "Pembayaran pesanan",
    "ZFFS_HDFK": "Cara pembayaran: COD",
    "BCFKJE": "Jumlah pembayaran kali ini",
    "YuE": "Saldo",
    "FuZhiZhangHao": "Salin akun",
    "WSZXCXZFPZ": "Tidak设置 konfigurasi pembayaran mini program",
    "XCXZFZHJY": "Akun pembayaran mini program dinonaktifkan",
    "SRZFJE": "Masukkan jumlah pembayaran",
    "FuKuanZhangHu": "Akun pembayaran",
    "QueRenZhiFu": "Konfirmasi pembayaran",
    "ShaoHouZhiFu": "Bayar nanti",
//order
    "FKJLYTJ_DD": "Riwayat pembayaran telah ditambahkan, menunggu审核 keuangan",
    "JiXuGuang": "Lanjut berkeliling",
    "BenCiFuKuan": "Pembayaran kali ini",
    "FuKuanChengGong": "Pembayaran berhasil",
    "ZhiFuFangShi": "Cara pembayaran",
    "ZhiFuDingDan": "Pesanan pembayaran",
//order-batch-pay
    "QXXZSXZFDD": "Silakan pilih pesanan yang perlu dibayar terlebih dahulu",
    "PiLiangFuKuan": "Pembayaran batch",
    "FuKuan": "Bayar",
    "'QuFuKuan'": "Pergi bayar",
//order-create-result
    "YingFuJinE": "Jumlah yang harus dibayar",
    "XiaDanShiJian": "Waktu pemesanan",
//order-deliver
    "SFQRSH": "Apakah Anda yakin ingin menerima?",
    "DDQRSH_": "Konfirmasi penerimaan pesanan?",
    "DFHSP": "Produk menunggu pengiriman",
    "ShangPinShuLiang": "Jumlah produk",
    "ChuKuShiJian": "Waktu keluar gudang",
    "FaHuoShiJian": "Waktu pengiriman",
    "WuLiuBeiZhu": "Catatan logistik",
    "QueRenShouHuo": "Konfirmasi penerimaan",
    "RYFK_QJSYG": "Jika sudah membayar, silakan hubungi administrator segera",
    "QSRQXYY": "Silakan masukkan alasan pembatalan",
    "H_DDJZDGB_QJKF": "setelah itu, pesanan akan otomatis ditutup, silakan bayar secepatnya",
    "TuiHuoQingKuang": "Kondisi pengembalian",
    "DingDanZongE": "Total pesanan",
    "DingDanBeiZhu": "Catatan pesanan",
    "FaHuoQingKuang": "Kondisi pengiriman",
    "DingDanFuJian": "Lampiran pesanan",
    "ShenQingTuiHuo": "Ajukan pengembalian",
    "G1TDSHJL_QRS": "Total {num} catatan menunggu penerimaan, konfirmasi penerimaan?",
    "DaiXiaDan": "Pemesanan atas nama",
    "DingDanHao": "Nomor pesanan",
    "XiaDanFangShi": "Cara pemesanan",
    "TuiHuoDan": "Pesanan pengembalian",
    "ShangPinZongE": "Total produk",
    "YunFei_ZongZhong": "Biaya pengiriman (total berat",
    "SF_SPWS": "Pajak (produk tidak termasuk pajak",
    "TePiJia": "Harga khusus",
    "FuKuanQingKuang": "Kondisi pembayaran",
    "TiaoJiLu": "catatan",
    "ZaiLaiYiDan": "Pesan lagi",
    "QDSCGDD_": "Yakin ingin menghapus pesanan ini?",
    "YiQueRen": "Sudah dikonfirmasi",
    "YiShouHuo": "Sudah diterima",
    "DaiFuJinE": "Jumlah yang harus dibayar",
    "YiFuJinE": "Jumlah yang sudah dibayar",
    "ZanWuJiLu": "Tidak ada catatan",
    "SPMC_DDH": "Nama produk / Nomor pesanan",
    "FuKuanZhuangTai": "Status pembayaran",
    "FaHuoZhuangTai": "Status pengiriman",
    "QiShiShiJian": "Waktu mulai",
    "ZhongZhiShiJian": "Waktu berakhir",
//order-list
    "CaoZuoChengGong": "Operasi berhasil",
    "ZBKGM": "Tidak dapat dibeli untuk sementara",
    "DQDDSPYXJ": "Produk pesanan saat ini telah diunduh",
    "DQDDBFSPYXJ": "Sebagian produk pesanan saat ini telah diunduh",
    "JTJSJSP": "Hanya menambahkan produk yang diunggah",
    "DingHuoDan": "Pesanan pemesanan",
//order-log
    "DingDanRiZhi": "Log pesanan",
//order-logistics
    "FuZhiChengGong": "Salin berhasil",
    "FuZhiShiBai": "Salin gagal",
    "FuZhi": "Salin",
    "BoDa": "Telpon",
    "WCWLDHXX": "Tidak ada informasi nomor resi logistik ini",
//order-pay
    "ZFCS_QCXXD": "Pembayaran超时, silakan pesan kembali",
    "YQYYCKZF": "Pembayaran deposit telah diaktifkan",
    "BNDYDFKJE": "Tidak boleh lebih dari jumlah yang harus dibayar",
    "ZFJEBNWK": "Jumlah pembayaran tidak boleh kosong",
    "QXAPFK_FKH": "Silakan安排 pembayaran terlebih dahulu, setelah membayar, unggah tangkapan layar informasi pembayaran, untuk keuangan memastikan jumlah",
    "DDTJCG_QJS": "Pesanan berhasil dikirim, silakan bayar segera",
    "QXZFKFS": "Silakan pilih cara pembayaran",
    "SYYEZFH_HX": "Setelah menggunakan pembayaran saldo, masih perlu membayar",
//
    "FuKuanJiLu": "Riwayat pembayaran",
    "ZWFKJL": "Tidak ada riwayat pembayaran",
    "FuKuanXiangQing": "Detail pembayaran",
    "FuKuanJinE": "Jumlah pembayaran",
    "ZhiDan": "Buat dokumen",
    "ShenHe": "审核",
    "ZuoFei": "Batal",
    "ZuoFeiYuanYin": "Alasan pembatalan",
    "GLDHD": "Pesanan pemesanan terkait",
    "HeXiaoJinE": "Jumlah verifikasi",
    "HeXiaoZhuangTai": "Status verifikasi",
    "DanJuZhuangTai": "Status dokumen",
    "KeHuMingCheng": "Nama pelanggan",
    "ZhangDanHao": "Nomor tagihan",
    "ShouKuanZhangHao": "Akun penerimaan",
    "ShouKuanShiJian": "Waktu penerimaan",
    "FuKuanPingZheng": "Bukti pembayaran",
    "GeFuJian": "lampiran",
//order-statistics
    "DingDanTongJi": "Statistik pesanan",
    "DingHuo": "Pemesanan",
    "Bi": "transaksi",
//order-statistics-detail
    "DDTJMX": "Detail statistik pesanan",
    "AGGTJ": "Statistik berdasarkan spesifikasi",
    "AFLTJ": "Statistik berdasarkan kategori",
    "DDJE_Y": "Jumlah pesanan/yuan",
    "DHSP_Z": "Produk pemesanan/jenis",
    "DingHuoDan_Bi": "Pesanan pemesanan/transaksi",
    "DingHuoShangPin": "Produk pemesanan",
    "JinE": "Jumlah",
//refund-list
    "TuiHuo": "Pengembalian",
//refund-apply
    "THDHWBC_QD": "Pesanan pengembalian belum disimpan, yakin ingin keluar?",
    "QSRSQTHJE": "Silakan masukkan jumlah pengembalian yang diminta",
    "QSRTHJE": "Silakan masukkan jumlah pengembalian",
    "QSRBZXX": "Silakan masukkan informasi catatan",
    "YingTuiJinE": "Jumlah yang harus dikembalikan",
    "TJTHSQ": "Kirim permintaan pengembalian",
    "QXXZDHQD": "Silakan pilih daftar pemesanan terlebih dahulu",
    "DingHuoQingDan": "Daftar pemesanan",
    "SQTHJE": "Jumlah pengembalian yang diminta",
    "DJXZSP": "Klik untuk memilih produk",
    "TuiHuoJinE": "Jumlah pengembalian",
//refund-detail
    "THDDXQ": "Detail pesanan pengembalian",
    "YiTuiHuo": "Sudah dikembalikan",
    "YiTuiKuan": "Sudah dikembalikan dana",
    "THDZT": "Status pesanan pengembalian",
    "TuiHuoDanHao": "Nomor pesanan pengembalian",
    "TuiHuoShiJian": "Waktu pengembalian",
    "TuiHuoCangKu": "Gudang pengembalian",
    "THLXR": "Kontak pengembalian",
    "TuiHuoQingDan": "Daftar pengembalian",
    "TuiKuanZongE": "Total pengembalian dana",
    "TuiKuanQingKuang": "Kondisi pengembalian dana",
    "DaiTuiJinE": "Jumlah yang harus dikembalikan",
    "YiTuiJinE": "Jumlah yang sudah dikembalikan",
//refund-product
    "SPMC_BH_GG": "Nama produk / Nomor / Nomor spesifikasi / Kode batang",
    "GZD1TJG": "Total ditemukan 1 hasil",
    "JiaRuQingDan": "Tambahkan ke daftar",
//refund-result
    "ShenQingChengGong": "Pengajuan berhasil",
    "THDTJCG": "Pesanan pengembalian berhasil dikirim",
    "ChaKanXiangQing": "Lihat detail",
//goods-package-floor
    "HDWKS_WDZL": "Acara belum dimulai, datang lagi nanti",
    "HDYJS_XCZD": "Acara telah berakhir, datang lebih awal下次",
    "ZWSZBT": "Judul belum diatur",
    "ChaKanGengDuo": "Lihat lebih banyak",
//goods-promotion-floor
    "HCDZSJC": "Selisih waktu akibat cache",
    "DLCKCXJ": "Login untuk melihat harga promosi",
    "ZWSZCX": "Promosi belum diatur",
    "JuKaiShi": "Sampai dimulai",
    "Song": "Berikan",
    "JuJieShu": "Sampai berakhir",
    "YiJieShu": "Telah berakhir",
//search-floor
    "XiaoXi": "Pesan",
    "SaoMaXiaDan": "Pindai dan pesan",
//home-page-custom
    "WZLCSJ": "Data lantai unknown",
//jump-error
    "QXZYSDHAPP": "Silakan unduh aplikasi 云上订货",
    "QMTYQYGLD": "Pengalaman penuh admin perusahaan",
    "XZYSDHAPP": "Unduh aplikasi 云上订货",
    "HQGLDWZTY": "Dapatkan pengalaman penuh admin",
    "JXTYDHD": "Lanjutkan pengalaman pemesanan",
    //notice-detail
    "GongGaoXiangQing": "Detail Pengumuman",
    "GongGaoFuJian": "Lampiran Pengumuman",
//shop-error
    "NFWDYMBCZO": "Halaman yang Anda akses tidak ada~",
    "KeNengYuanYin": "Mungkin Alasan",
    "1_ZDZLSRCWD": "1. Memasukkan alamat yang salah di bilah alamat;",
    "2_DJLGQLJ": "2. Menekan tautan yang kedaluwarsa.",
//shop-index
    "GuanLiDuan": "Admin Panel",
    "ZhuCe": "Daftar",
    "HYNTYYSDH": "Selamat datang menggunakan Yunshang Order",
    "TYZHSJHDQG": "Data akun uji coba akan diperbarui secara berkala, mohon jangan memasukkan informasi penting",
    "TYZHZDNRSJ": "Semua data konten dalam akun uji coba adalah fiktif, mohon jangan memasukkan informasi penting",
    "ZHZCCG": "Pendaftaran akun berhasil",
    "DengLuZhangHao": "Masuk Akun",
    "CSMMW": "Kata sandi awal adalah",
    "GNFYHQL": "Kami telah mengirimkan kupon kepada Anda!",
    "Man1YuanKeYong": "Dapat digunakan jika满{num} yuan",
    "LQH1TNKY": "Dapat digunakan dalam {day} hari setelah menerima kupon",
    "YiJianLingQu": "Terima Sekali Klik",
    "GXNHD1ZYHQ": "Selamat! Anda mendapatkan 1 kupon",
    "Gong1Yuan": "Total 1 yuan",
    "LiJiShiYong": "Gunakan Segera",
//shop-login
    "NHWDL": "Anda belum masuk",
//shop-notice
    "ShangChengGongGao": "Pengumuman Mall",
    "ZanWuGongGao": "Belum ada Pengumuman",
    "1GeFuJian": "{num} lampiran",
//deposit-detail
    "KouKuan": "Potongan Dana",
    "ChongZhi_Kuan": "Isi Ulang Dana",
    "KouKuanZuoFei": "Potongan Dana Dibatalkan",
    "ChongZhiZuoFei": "Isi Ulang Dana Dibatalkan",
    "ZhangHuMingXi": "Detail Akun",
    "ZhangHuYuE": "Saldo Akun",
    "LiJiChongZhi": "Isi Ulang Segera",
//deposit-recharge
    "CZJEBNXY1Y": "Jumlah isi ulang tidak boleh kurang dari 1 yuan",
    "QSRZQDSZ": "Mohon masukkan nilai yang benar",
    "ZDYJE": "Jumlah Kustom",
    "ZWKTXSCZGN": "Fungsi isi ulang online belum diaktifkan",
    "ShiFuJinE": "Jumlah Pembayaran Aktual",
    "ZhangHuChongZhi": "Isi Ulang Akun",
    "QXZCZJE": "Mohon pilih jumlah isi ulang",
    "QSRCZJE": "Mohon masukkan jumlah isi ulang",
    "QLXNDZSYWY": "Mohon hubungi salesman eksklusif Anda untuk isi ulang",
    "ShouJia": "Harga Jual",
    "YiShouQing": "Telah Habis",
    "ChongZhiJinE": "Jumlah Isi Ulang",
    "QueRenFuKuan": "Konfirmasi Pembayaran",
//deposit-recharge-result
    "QSDDID": "Kehilangan ID Pesanan",
    "ChongZhiChengGong": "Isi Ulang Berhasil",
    "ChongZhiShiBai": "Isi Ulang Gagal",
    "CLZ_QSH...": "Sedang diproses, mohon tunggu...",
    "ChongZhiFangShi": "Cara Isi Ulang",
    "ChongZhiShiJian": "Waktu Isi Ulang",
    "JYLSH": "Nomor Transaksi",
    "FanHuiShangCheng": "Kembali ke Mall",
//recharge-online
    "ZFSB_QCS": "Pembayaran gagal, mohon coba lagi",
    "ZFYQX": "Pembayaran telah dibatalkan",
    "ZFYC_QCS": "Pembayaran abnormal, mohon coba lagi",
//user
    "LingQuanZhongXin": "Pusat Mengambil Kupon",
    "WeiShiYong": "Belum Digunakan",
    "YiShiYong": "Telah Digunakan",
    "ZWYHQ": "Belum ada Kupon",
//keep-list
    "YiGouMai": "Telah Dibeli",
    "ChangYongQingDan": "Daftar Umum Digunakan",
    "WoDeShouCang": "Koleksi Saya",
    "QuGouWuChe": "Pergi ke Keranjang Belanja",
    "GeShangPin": "produk",
//login
    "YunShangDingHuo": "Yunshang Order",
    "QSRZH": "Mohon masukkan akun!",
    "QSRMM": "Mohon masukkan kata sandi!",
    "QSRDLZH": "Mohon masukkan akun login",
    "JiZhuMiMa": "Ingat Kata Sandi",
    "WangJiMiMa": "Lupa Kata Sandi?",
    "DengLu": "Masuk",
    "DLZHBCZ_QL": "Akun login tidak ada, mohon hubungi administrator untuk mengaktifkan",
    "GQYZHSBJY_": "Akun perusahaan ini telah dinonaktifkan, mohon hubungi Yunshang Order",
    "GQYZHSYQJS_": "Masa percobaan akun perusahaan ini telah berakhir, mohon hubungi Yunshang Order",
    "GQYZHYGQL_": "Akun perusahaan ini telah kedaluwarsa, perlu diperbarui untuk digunakan, mohon hubungi Yunshang Order",
    "LiJiTiYan": "Coba Segera",
//my-collect
    "YiChuChengGong": "Hapus Berhasil",
    "QueHuo": "Stok Habis",
    "YCSCJ": "Hapus dari Koleksi",
//order-message
    "SheZhiChengGong": "Pengaturan Berhasil",
    "ZWWDXX": "Belum ada pesan belum dibaca",
    "QuanBuYiDu": "Semua Telah Dibaca",
    "DingDanXiaoXi": "Pesan Pesanan",
    "YiQiang": "Telah Diambil",
    "LiJiLingQu": "Ambil Segera",
    "LingQuanHou": "Setelah Mengambil Kupon",
    "TianNeiKeYong": "dalam hari dapat digunakan",
    "QSRSJH": "Mohon masukkan nomor ponsel",
    "QSRYZM": "Mohon masukkan kode verifikasi",
    "QSRXMM": "Mohon masukkan kata sandi baru",
    "QSRZQSJGS": "Mohon masukkan format nomor ponsel yang benar",
    "ChongZhiMiMa": "Reset Kata Sandi",
    "QSRNDSJHM": "Mohon masukkan nomor ponsel Anda",
    "QSRDXYZ": "Mohon masukkan verifikasi SMS",
    "HQYZM": "Dapatkan Kode Verifikasi",
    "HKCXHQ": "dapat diambil kembali setelah",
    "QSR6_20WSZHZ": "Mohon masukkan kata sandi 6-20 karakter (angka atau huruf)",
//share-setting
    "QSRSPJGBL": "Mohon masukkan rasio harga produk",
    "SPJGBLBXDY": "Rasio harga produk harus lebih besar atau sama dengan 100, dan kurang dari 999.99",
    "DPMCZBZCTS": "Nama toko belum mendukung simbol khusus",
    "LXRZBZCTSF": "Kontak person belum mendukung simbol khusus",
    "LXFSZBZCTS": "Cara kontak belum mendukung simbol khusus",
    "LXDZZBZCTS": "Alamat kontak belum mendukung simbol khusus",
    "DPJJZBZCTS": "Deskripsi toko belum mendukung simbol khusus",
    "QSRDPJJ_ZD": "Mohon masukkan deskripsi toko, maksimal 50 karakter",
    "FenXiangSheZhi": "Pengaturan Berbagi",
    "NDWSCSPJG": "Harga produk mall mobile Anda",
    "NDDHJ_": "Harga pemesanan Anda ×",
    "LXXX_KBJ_": "Informasi Kontak (Dapat Diedit）",
    "DianPuMingCheng": "Nama Toko",
    "JianJie": "Deskripsi",
    "QSRDPMC": "Mohon masukkan nama toko",
    "LianXiRen": "Kontak Person",
    "QSRLXR": "Mohon masukkan kontak person",
    "LianXiFangShi": "Cara Kontak",
    "QSRLXFS": "Mohon masukkan cara kontak",
    "LianXiDiZhi": "Alamat Kontak",
    "QSRLXDZ": "Mohon masukkan alamat kontak",
//user
    "WoDeDingDan": "Pesanan Saya",
    "ZuiJinLiuLan": "Terakhir Dilihat",
    "ShouCangShangPin": "Produk Koleksi",
    "BDYYZH_ZC": "Bind Akun Sudah Ada | Daftar Akun Baru",
    "DL_ZC": "Masuk | Daftar",
    "BangDingShouJi": "Bind Nomor Ponsel",
    "TS_BDSJHM_": "Peringatan: Bind nomor ponsel untuk keamanan akun yang lebih baik!",
    "ChaKanQuanBu": "Lihat Semua",
    "ShouHuoDiZhi": "Alamat Pengiriman",
    "LianXiWoMen": "Hubungi Kami",
    "SheZhi": "Pengaturan",
    "QuQianDao": "Pergi Check-in",
    "JiFenShangCheng": "Mall Poin",
    "TuiGuangShangPin": "Promosikan Produk",
    "QuChaKan": "Pergi Lihat",
    "JiFenHuanLi": "Tukar Poin dengan Hadiah",
    "DYSPBQ": "Cetak Label Produk",
//user-about
    "GYYSDH": "Tentang Yunshang Order",
    "YQHYSMEWM_": "Undang teman untuk memindai kode QR, langsung unduh dan instal",
    "DangQianBanBen": "Versi Saat Ini",
//user-address
    "ZWSHDZ": "Belum ada Alamat Pengiriman",
    "WoDeDiZhi": "Alamat Saya",
    "ZhiNengShiBie": "Pengenalan Cerdas",
    "ZTDZXXKZNS": "Tempel informasi alamat untuk mengenali nama, nomor telepon, alamat secara cerdas",
    "MoRen": "Default",
    "QRSCDZ": "Yakin ingin menghapus alamat?",
    "SHRXM": "Nama Penerima",
    "SJHMHGDDHZ": "Setidaknya salah satu dari nomor ponsel atau telepon tetap harus diisi",
    "QSRSHRXM": "Mohon masukkan nama penerima",
    "ShouJiHaoMa": "Nomor Ponsel",
    "GuDingDianHua": "Telepon Tetap",
    "QSRGDDH": "Mohon masukkan telepon tetap",
    "SuoZaiDiQu": "Wilayah Tempat Tinggal",
    "QSRSZDQ": "Mohon masukkan wilayah tempat tinggal",
    "QSRXXDZ": "Mohon masukkan alamat detail!",
    "QSRZQDSJHM": "Mohon masukkan nomor ponsel yang benar",
    "QSRZQDGDDH": "Mohon masukkan telepon tetap yang benar",
    "XiangXiDiZhi": "Alamat Detail",
    "MoRenDiZhi": "Alamat Default",
    "SWMRDZ": "Set sebagai Alamat Default",
    "BCBSY": "Simpan dan Gunakan",
//user-bing-one
    "QSRSJHM": "Mohon masukkan nomor ponsel",
    "GYHYZC": "Pengguna ini telah terdaftar",
    "GSJHMYJZCG": "Nomor ponsel ini telah terdaftar",
    "QZJDLJK": "Mohon masuk langsung",
    "QuDengLu": "Pergi Masuk",
    "BDHKYTGSJH": "Setelah bind, Anda dapat masuk melalui nomor ponsel, memudahkan Anda untuk mengambil kembali kata sandi dan meningkatkan keamanan akun",
    "_BDHKYTGSJ": "*Setelah bind, Anda dapat masuk melalui nomor ponsel, memudahkan Anda untuk mengambil kembali kata sandi dan meningkatkan keamanan akun",
    "QSRSJYZM": "Mohon masukkan kode verifikasi ponsel",
    "BDXSJ": "Bind Nomor Ponsel Baru",
    "DXYZM": "Kode Verifikasi SMS",
    "XiaYiBu": "Langkah Selanjutnya",
    "TGCBZ": "Lewati Langkah Ini",
//user-bing-two
    "DBDSJHMBCZ": "Nomor ponsel yang akan di-bind tidak ada!",
    "QSRDLMM": "Mohon masukkan kata sandi login!",
    "_GSJHMYBDY": "*Nomor ponsel ini telah di-bind dengan akun Yunshang Order, verifikasi kata sandi login ponsel untuk bind akun saat ini",
    "DQZHMMJTBW": "Kata sandi akun saat ini akan disinkronkan menjadi kata sandi login ponsel",
    "DangQianZhangHao": "Akun Saat Ini",
//
    "QDYJZ": "Yakin ingin mengubah",
    "JSPSCM": "produk ini dihapus?",
    "ShanChuChengGong": "Hapus Berhasil!",
//user-info
    "SJGSCW": "Format nomor ponsel salah",
    "YXGSCW": "Format email salah",
    "WoDeZhangHao": "Akun Saya",
    "YouXiang": "Email",
    "ShouJi": "Ponsel",
    "XingMing": "Nama",
    "XiuGaiTouXiang": "Ubah Avatar",
    "JiBenXinXi": "Informasi Dasar",
    "ZhangHaoAnQuan": "Keamanan Akun",
    "XiuGaiMiMa": "Ubah Kata Sandi",
    "DianJiBangDing": "Klik untuk Bind",
    "RYDSHTY_QL": "Jika telah hilang atau tidak digunakan lagi, mohon ganti segera untuk避免 akun dicuri",
    "WBZNDZHAQ_": "Untuk menjamin keamanan akun Anda, mohon bind nomor ponsel",
    "QSRNDXM": "Mohon masukkan nama Anda",
    "QSRNDDH": "Mohon masukkan nomor telepon Anda",
    "QSRNDYX": "Mohon masukkan email",
//user-setting
    "QCHCHXCXDL": "Setelah membersihkan cache, perlu masuk kembali",
    "QingChuHuanCun": "Membersihkan Cache",
    "QDYQCHCM": "Yakin ingin membersihkan cache?",
    "TuiChuDengLu": "Keluar dari Login",
    "QieHuanZhangHao": "Ganti Akun",
//user-supplier
    "LianXi": "Hubungi",
    "GongSiDianHua": "Nomor Telepon Perusahaan",
    "DiZhi": "Alamat",
//vouchers-detail
    "DJQMX": "Detail Kupon Uang",
//vouchers-list
    "BuKeYong": "Tidak Dapat Digunakan",
    "KeYong": "Dapat Digunakan",
    "ZWDJQ": "Belum ada Kupon Uang",
    "ZongEDu": "Total Kuota",
    "FaFangShiJian": "Waktu Pendistribusian",
    "EDYYW": "Kuota Telah Habis",
    "QBSPKY": "Semua Produk Dapat Digunakan",
//vouchers-select-list
    "WDDJQ": "Kupon Uang Saya",
    "KYDJQ": "Kupon Uang yang Dapat Digunakan",
    "DJQKDK": "Kupon Uang Dapat Dibayarkan",
    "CKKYSP": "Lihat Produk yang Dapat Digunakan",
    "BKYDJQ": "Kupon Uang yang Tidak Dapat Digunakan",
    "BKYYY_ZWFH": "Alasan tidak dapat digunakan: Belum ada produk yang memenuhi syarat",
//goods-detail
    "DQSPWSCGGT": "Produk saat ini belum mengunggah gambar spesifikasi, tidak mendukung pengaturan lampu!",
    "BoFangShiPin": "Putar Video",
    "Gong1GeGuiGe": "Total {num} spesifikasi",
    "YiXuanGuiGe": "Spesifikasi yang Telah Dipilih",
    "XuanGuiGe": "Pilih Spesifikasi",
    "LingQuan": "Ambil Kupon",
    "1ZhongCuXiao": "1 Jenis Promosi",
    "1ZhangKeYong": "1 Lembar Dapat Digunakan",
    "ZuiGaoKeSheng": "Maksimal Hemat",
    "ShangPinTaoCan": "Paket Produk",
    "Gong1GeTaoCan": "Total 1 Paket",
    "ShangPinCanShu": "Parameter Produk",
    "ZhanKai": "Buka",
    "YiShouCang": "Telah Koleksi",
    "ShouCang": "Koleksi",
    "KeFu": "Layanan Pelanggan",
    "XiangQing": "Detail",
    "TuiJian": "Rekomendasi",
    "BianHao": "Nomor",
    "ShangPinXinXi": "Informasi Produk",
    "KLYHQ": "Dapat Mengambil Kupon",
    "KuCunBuZu": "Stok Tidak Cukup",
    "DuoGuiGe": "Banyak Spesifikasi",
    "YiShou": "Telah Dijual",
    "SWBHZ_YS": "Sedang isi stok, telah dijual",
    "CuXiaoShangPin": "Produk Promosi",
//goods-search
    "NHWSRSSNR": "Anda belum memasukkan konten pencarian",
    "SouSuo": "Cari",
    "SSY1XGDSP": "Cari produk terkait dengan {searchKey}",
    "Yue1GeShangPin": "Sekitar {num} produk",
    "ZuiJinSouSuo": "Pencarian Terakhir",
    "QingChu": "Hapus",
    "ZWSSJL": "Belum ada Riwayat Pencarian",
//goods-property
    "ZGJGBNDYZD": "Harga tertinggi tidak boleh kurang dari harga terendah",
    "ShangPinBiaoQian": "Label Produk",
    "BuGaoYu1": "Tidak lebih dari 1",
    "BuDiYu1": "Tidak kurang dari 1",
    "FengGe": "Gaya",
//goods-promotion-list
    "JiJiangKaiShi": "Akan Segera Dimulai",
    "QuanBuCuXiao": "Semua Promosi",
//goods-package-list
    "Gong1JianShangPin": "Total 1 Produk",
    "Sheng": "Hemat",
//goods-package-detail
    "GTCZGWCZDS": "Jumlah paket ini di keranjang telah mencapai batas pembelian, tidak dapat ditambahkan ke keranjang",
    "GTCKCBZ_BK": "Stok paket ini tidak cukup, tidak dapat ditambahkan ke keranjang",
    "JinSheng1Tao": "Hanya tersisa 1 paket",
    "XianGou1Tao": "Batas pembelian 1 paket",
    "TaoCanXiangQing": "Detail Paket",
    "DanMaiJia": "Harga Beli Satuan",
    "TaoCanJia": "Harga Paket",
    "HDYJS": "Acara Telah Berakhir",
//goods-message
    "WDL_QXDL": "Belum masuk, mohon masuk terlebih dahulu",
//goods-list-label
    "XinPinShangShi": "Produk Baru Dibuat",
    "WDLZH_ZWCX": "Belum masuk akun, belum ada aktivitas promosi!",
    "YiXiaShangPin": "Produk di bawah ini",
//goods-list
    "1ZhongGuiGe": "1 Jenis Spesifikasi",
    "YouKuCun": "Ada Stok",
//goods-filter
    "BuGaoYu": "Tidak lebih dari",
    "BuDiYu": "Tidak kurang dari",
    "CuXiao": "Promosi",
    "ZDYXXZ3G": "Maksimal diizinkan memilih 3",
    "GouMai": "Beli",
    "Gong1Jian": "Total {num} item",
//已订货商品
    "DLHCKJG": "Masuk untuk melihat harga",
    "M1JZ1J": "Dapatkan {presentNum} item jika满{num} item",
    "CZPF_ZZCXC": "Operasi terlalu sering, sedang mencoba kembali",
    "XSZJJXZ": "Potongan langsung terbatas waktu sedang berlangsung",
    "YXSPM1YZ1J_": "Produk di bawah ini {str}, tambahkan ke keranjang untuk menikmati promosi!",
    "TiaoXingMa": "Kode Batang",
    "XiangGuanTuiJian": "Rekomendasi Terkait",
    "YSSPBKJRGW": "Produk pre-order tidak dapat ditambahkan ke keranjang, kami telah menambahkan produk non-pre-order untuk Anda!",
    "YSSPBKLJGM": "Produk pre-order tidak dapat dibeli langsung, mohon hapus produk pre-order dan beli kembali!",
    "SPSLYW": "Jumlah produk salah",
    "ShangPin1QiShou": "Produk {num} mulai dijual",
    "SPDGSLBNCG": "Jumlah pemesanan produk tidak boleh lebih dari {num}",
    "QRYCXZSP": "Yakin ingin menghapus produk yang dipilih",
    "QRYCSYSXSP": "Yakin ingin menghapus semua produk yang tidak berlaku",
    "QRYCXZSXSP": "Yakin ingin menghapus produk tidak berlaku yang dipilih",
    "M1YZ1J": "Dapatkan {presentNum} item jika满{num} yuan",
    "M1YJ1Y": "Dapatkan potongan {money} yuan jika满{price} yuan",
    "M1J1": "Dapatkan potongan {money} jika满{price}",
    "M1YD1Z": "Dapatkan diskon {money} jika满{price} yuan",
    "DDM1YHZ": "Pesanan akan mendapatkan hadiah jika满{price} yuan",
    "YiHuoZeng": "Telah Mendapatkan Hadiah",
    "ZG1YLXM1YZ1": "Beli lagi {price} yuan untuk menikmati {str}",
    "ZG1JLXM1JZ1": "Beli lagi {num} item untuk menikmati {str}",
    "QCSXSP": "Hapus Produk Tidak Berlaku",
    "YiXuanShangPin": "Produk yang Telah Dipilih",
    "QuJieSuan": "Pergi ke Penyelesaian",
    "ShiXiaoShangPin": "Produk Tidak Berlaku",
    "DingDanGuanLi": "Manajemen Pesanan",
    "ZhuangTai": "Status",
    "ShangPinChuKu": "Produk Keluar Gudang",
    "DengDaiShouHuo": "Menunggu Penerimaan",
    "PeiSongXinXi": "Informasi Pengiriman",
    "FuKuanXinXi": "Informasi Pembayaran",
    "GDFKJL": "Lebih Banyak Riwayat Pembayaran",
    "WuLiuFuJian": "Lampiran Logistik",
    "ZanWuFuJian": "Belum ada Lampiran",
    "YiFa": "Telah Dikirim",
    "YingFuZongE": "Total yang Harus Dibayar",
    "FuKuanShiJian": "Waktu Pembayaran",
    "ZhangHuHaoMa": "Nomor Akun",
    "KeYongYuE": "Saldo yang Dapat Digunakan",
    "TianJiaChengGong": "Tambah Berhasil",
    "ShanChuDiZhi": "Hapus Alamat",
    "QXZSHDZ": "Mohon pilih alamat pengiriman",
    "YiHuoZengPin": "Telah Mendapatkan Hadiah Tambahan",
    "YiYouHui1Yuan": "Telah mendapatkan potongan {money} yuan",
    "QWSFPXX": "Mohon lengkapi informasi faktur",
    "1ZSP": "{num} Jenis Produk",
    "Gong": "Total",
    "Jian": "item",
    "ShangPinJinE": "Jumlah Produk",
    "YunFeiDaoFu": "Biaya Pengiriman Dibayar Nanti",
    "QSRZQDSHRX": "Mohon masukkan nama penerima yang benar",
    "QSRZQDXXDZ": "Mohon masukkan alamat detail yang benar",
    "DBQ_MYZDDY": "Maaf, halaman yang sesuai tidak ditemukan",
    "ShouHuoChengGong": "Penerimaan Berhasil",
    "Hi_HuanYingNin": "Hi, Selamat Datang",
    "YiFaEWuLiu": "Telah mengirim e-logistik",
    "NinDeDingDan": "Pesanan Anda",
    "ZBNBHBQ": "tidak boleh berisi emoji",
    "XMBNWK": "Nama tidak boleh kosong",
    "XiTongSheZhi": "Pengaturan Sistem",
    "ZhangHaoXinXi": "Informasi Akun",
    "QingShuRuXingMing": "Mohon masukkan nama",
    "QWSZL_JZYG": "Mohon lengkapi data, akan membantu layanan yang lebih baik untuk Anda",
    "QSRZQDYXGS": "Mohon masukkan format email yang benar",
    "QTXZQDCWXX": "Mohon isi informasi keuangan yang benar, agar mitra Anda dapat mencetak faktur untuk Anda",
    "GXSHDZCG": "Perbarui alamat pengiriman berhasil",
    "BCSHDZCG": "Simpan alamat pengiriman berhasil",
    "XinZengDiZhi": "Tambah Alamat Baru",
    "QXZYQXSCDS": "Mohon pilih produk yang akan dibatalkan koleksinya",
    "QuXiaoShouCang": "Batalkan Koleksi",
    "XuanZeGuiGe": "Pilih Spesifikasi",
    "CaiWuGuanLi": "Manajemen Keuangan",
    "DuiZhangMingXi": "Detail Reconciliasi",
    "QSRLWJL_JE": "Mohon masukkan riwayat hubungan/ jumlah",
    "YiGouMai1Ci": "Telah membeli {count} kali",
    "6_1GouMai": "{time} membeli",
    "TZGGXQ": "Detail Pengumuman Pemberitahuan",
    "ZYXSCSP": "Hanya diizinkan mengunggah video",
    "SCSPDXBYXC": "Ukuran video yang diunggah tidak boleh melebihi {size}",
    "YDHSP": "Produk yang Telah Dipesan",
    "ShangPinPinPai": "Merek Produk",
    "ShangPinLieBiao": "Daftar Produk",
    "LingShouJia": "Harga Eceran",
    "YouHuiJia": "Harga Diskon",
    "LiJiGouMai": "Beli Segera",
    "ZhuTu": "Gambar Utama",
    "WuXianZhi": "Tidak Ada Batas",
    "XiaoJi": "Subtotal",
    "SCXZSP": "Hapus Produk yang Dipilih",
    "QSRDDH": "Mohon masukkan nomor pesanan",
    "QSRDDH_SPMC": "Mohon masukkan nomor pesanan/ nama produk",
    "CaoZuo": "Operasi",
    "WuLiuXinXi": "Informasi Logistik",
    "CaoZuoLeiXing": "Tipe Operasi",
    "CaoZuoRiZhi": "Log Operasi",
    "CaoZuoShiJian": "Waktu Operasi",
    "ZhangHuMingCheng": "Nama Akun",
    "KaiHuYinHang": "Bank Pendiri",
    "DDTJCG_XZZC": "Pesanan berhasil dikirim, sekarang hanya tinggal langkah terakhir",
    "ZhiFuJinE": "Jumlah Pembayaran",
    "DZFJE": "Jumlah yang Harus Dibayar",
    "QTXYXSMB": "Silakan isi beberapa keterangan",
    "XZSKYHZH": "Pilih Akun Bank Penerima",
    "TiShi": "Peringatan",
    "NHY1GDDGJ1Y": "Anda masih memiliki {num} pesanan dengan total {money} yuan yang belum dibayar",
    "QKJQHCKJXX": "Pesanan baru dapat dibuat setelah tagihan lunas",
    "HDDDXX": "Verifikasi Informasi Pesanan",
    "BJSHDZ": "Edit Alamat Pengiriman",
    "TongZhiGongGao": "Pemberitahuan Pengumuman",
    "YinHangZhangHao": "Nomor Akun Bank",
    "XiuGaiShouJi": "Ubah Nomor Ponsel",
    "LXRXX": "Informasi Kontak Person",
    "GSCWXX": "Informasi Keuangan Perusahaan",
    "QSRKHYHMCJ": "Mohon masukkan nama bank pendiri dan cabang pendiri",
    "QSRYHZH": "Mohon masukkan nomor akun bank",
    "PiLiangCaoZuo": "Operasi Batch",
    "GouMaiJiLu": "Riwayat Pembelian",
    "TongZhiBiaoTi": "Judul Pemberitahuan",
    "FaBuShiJian": "Waktu Publikasi",
    "XiaoXiLeiXing": "Tipe Pesan",
    "XiaoXiNeiRong": "Isi Pesan",
    "JieShouShiJian": "Waktu Penerimaan",
    "QuanBuPinPai": "Semua Merek",
    "WXSYS_DHGBJ": "Scan dengan WeChat, pemesanan lebih mudah",
    "GZWXGZH": "Ikuti Akun Resmi WeChat",
    "FuWuReXian": "Hotline Layanan",
    "SouSuoLiShi": "Riwayat Pencarian",
    "QuanBuShanChu": "Hapus Semua",
    "NH_HYLDYSDH": "Halo, selamat datang di {company}!",
    "ZSJDH": "Pesan di ponsel",
    "SYS_GZWXGZH": "Scan, ikuti akun resmi WeChat",
    "GuanZhuWoMen": "Ikuti Kami",
    "QBSPFL": "Semua Kategori Produk",
    "QuPeiDeng": "Pergi Pasang Lampu",
    "KuanXiang": "Uang",
    "QSRSPMC_GG_": "Mohon masukkan nama produk/ spesifikasi/ nomor/ huruf awal",
    "NH_HYLDYSD": "Halo, selamat datang di Mall Yunshang Order!",
    "ReXiao": "Populer",
    "20Tiao_Ye": "20 baris/ halaman",
    "ShiChangJia_": "Harga Pasar：",
    "_134.10Qi": "Mulai dari S/ 134.10",
    "HJ_BHYF": "Total (tanpa biaya pengiriman)：",
    "QDSCXZSP_": "Yakin ingin menghapus produk yang dipilih?",
    "QDQCXJSP_": "Yakin ingin menghapus produk yang diunduh?",
    "DDTJCG_XZZ": "Pesanan berhasil dikirim, sekarang hanya tinggal langkah terakhir!",
    "XuanZeZhangHu": "Pilih Akun",
    "DaiZhiFu": "Menunggu Pembayaran",
    "CaiGouDingDan": "Pesanan Pembelian",
    "DingDanXinXi": "Informasi Pesanan",
    "TuiChu": "Keluar",
    "KaiHuMingCheng": "Nama Pendiri",
    "QSRKHMC": "Mohon masukkan nama pendiri",
    "_QTXZQDCWX": "（Mohon isi informasi keuangan yang benar, agar mitra Anda dapat mencetak faktur untuk Anda）",
    "ShouHuoRen": "Penerima",
    "SWMRSHDZ": "Set sebagai Alamat Pengiriman Default",
    "TianJiaDiZhi": "Tambah Alamat",
    "Gong4GeGuiGe": "Total 4 Spesifikasi",
    "Zhi": "Hanya",
    "Kuai": "potong",
    "Tou": "ekor",
    "Xiang": "kotak",
    "Ping": "botol",
    "KaiShiRiQi": "Tanggal Mulai",
    "JieShuRiQi": "Tanggal Berakhir",
    "YiXuan": "Telah Dipilih",
    "ZhiFuZhuangTai": "Status Pembayaran",
    "QDLCKJG": "Mohon masuk untuk melihat harga",
    "YZMBZQ": "Kode verifikasi tidak benar",
    "ZhiFuJiLu": "Riwayat Pembayaran",
    "ShangPinMingCheng": "Nama Produk",
    "DingGouShuLiang": "Jumlah Pemesanan",
    "TuiHuoShuLiang": "Jumlah Pengembalian",
    "QSRTHNR": "Mohon masukkan isi pengembalian",
    "SCTHSM": "Unggah Keterangan Pengembalian",
    "ShenQingShiJian": "Waktu Pengajuan",
    "ShenQingJinE": "Jumlah Pengajuan",
    "TuiHuoYuanYin": "Alasan Pengembalian",
    "TuiHuoShuoMing": "Keterangan Pengembalian",
    "TuiDanHao": "Nomor Pesanan Pengembalian",
    "SXCZ_XDCG": "Kredit cukup, pesanan berhasil",
    "SXEDBZ_FKHFH": "Kredit tidak cukup, akan dikirim setelah pembayaran",
    "CGJKZQ_FKFH": "Melebihi siklus pinjaman, dikirim setelah pembayaran",
    "DDTJCG_XZZCZHYB": "Pesanan berhasil dikirim, sekarang hanya tinggal langkah terakhir!",
    "QNZ_NWCFK_FZ": "Mohon selesaikan pembayaran dalam {time}, jika tidak pesanan akan dibatalkan secara otomatis.",
    "MianFeiLing": "Dapatkan Gratis",
    "M_KMFLQ_HQ": "Dapatkan gratis jika满{target} yuan, masih kurang {short} yuan",
    "YHDMFSP": "Telah Mendapatkan Produk Gratis",
    "JRMFL": "Dapatkan Gratis Hari Ini",
    "LingGuangLe": "Telah Habis Diambil",
    "KeLingQu": "Dapat Diambil",
    "QSRZFJE": "Mohon masukkan jumlah pembayaran",
    "QNJKFK_WMJKWNCL": "Mohon bayar secepatnya, kami akan memproses pesanan Anda secepatnya!",
    "XianXiaTiYanGuan": "Gedung Eksperimen Offline",
    "QingXuanZheSheng": "Mohon pilih Provinsi",
    "QingXuanZheShi": "Mohon pilih Kota",
    "ZhanGuanDiZhi": "Alamat Gedung Pameran",
    "YingYeShiJian": "Waktu Operasional",
    "ZhanGuanDianHua": "Nomor Telepon Gedung Pameran",
    "FenXiang": "Bagikan",
    "TiYanGuanJieShao": "Deskripsi Gedung Eksperimen",
    "DPYDY_QSHX": "Toko telah tutup, mohon pesan nanti",
    "DaYangShiJian": "Waktu Tutup",
    "IMEI": "Nomor Seri (IMEI)",
    "FanKuanYuE": "Saldo Refund",
    "FanKuanZhiFu": "Pembayaran Refund",
    "YiShengZhiFu": "Yisheng Payment",
    "JiongDongShouYinTai": "Kasir JD",
    "FKYEBZ": "Saldo Refund Tidak Cukup",
    "FanKuanZhangHu": "Akun Refund",
    "HaiXuZhiFu": "Masih perlu membayar {price}",
    "FaPiaoMingXi": "Detail Faktur",
    "FaPiaoZhuShou": "Asisten Faktur",
    "WoDeFaPiao": "Faktur Saya",
    "FaPiaoXiangQing": "Detail Faktur",
    "KaiPiaoShiJian": "Waktu Pencetakan Faktur",
    "DaiKaiFaPiao": "Faktur yang Akan Dicetak",
    "DKFPJE": "Jumlah Faktur yang Akan Dicetak",
    "KaiPiaoJinE": "Jumlah Faktur",
    "GuanLianDanHao": "Nomor Dokumen Terkait",
    "ChuangJianShiJian": "Waktu Pembuatan",
    "ZhiFuPingZheng": "Bukti Pembayaran",
    "QSRZQNR": "Mohon masukkan isi yang benar",
    "QSRTDH_SPMC": "Mohon masukkan nomor pesanan pengembalian/ nama produk",
    "ShangPinRuKu": "Produk Masuk Gudang",
    "TuiKuanChuLi": "Proses Refund",
    "YuanDingDanHao": "Nomor Pesanan Asli",
    "TuiHuoXinXi": "Informasi Pengembalian",
    "TuiKuanXinXi": "Informasi Refund",
    "TuiKuanZhuangTai": "Status Refund",
    "ZWTKJL": "Belum ada Riwayat Refund",
    "GDTKJL": "Lebih Banyak Riwayat Refund",
    "DDDKFQRBJQSH": "Pesanan menunggu konfirmasi penawaran dari CS, mohon tunggu",
    "BNSRDYHDTSZF": "Tidak dapat memasukkan karakter khusus seperti tanda kutip tunggal",
    "THSLBNWK": "Jumlah pengembalian tidak boleh kosong",
    "BZBNBHBQ": "Catatan tidak boleh berisi emoji",
    "THSLBKDYKTHSL": "Jumlah pengembalian lebih dari jumlah yang dapat dikembalikan",
    "DDM_YZ_J": "Pesanan akan mendapatkan {number} item jika满{target} yuan",
    "M_JZ_J": "Pesanan akan mendapatkan {number} item jika满{target} item",
    "M_JJZ_Y": "Pesanan akan turun menjadi {money} yuan jika满{target} item",
    "YDHJJZ_Y": "Harga pemesanan asli turun menjadi {price} yuan",
    "M_JD_Z": "Pesanan akan mendapatkan diskon {percent} jika满{number} item",
    "YDHJD_Z": "Harga pemesanan asli mendapatkan diskon {percent}",
    // Mercado Pago支付
    "WDSYT": "Kasir Saya",
    "ZZSYMPSMJY": "Sedang menggunakan transaksi scan dengan Mercado Pago",
    "SKF": "Pihak Penerima",
    "SYSFK": "Scan untuk Bayar",
    "DDXQ": "Detail Pesanan",
    "YUAN": "yuan",
    // 优惠券
    "GXNHQ_Z_Y_": "Selamat! Anda mendapatkan {num} lembar {price} yuan {name}",
    "QBLX": "Semua Tipe",
    "QLQZX": "Pergi ke Pusat Mengambil Kupon",
    "YLYH": "Promosi Telah Diambil",
    "MZTJJKSY": "Dapat digunakan jika memenuhi syarat",
    "GXNHD_Z_YHQ": "Selamat! Anda mendapatkan {num} lembar kupon",
    "G_Y": "Total {price} yuan",
    "XZYHQ": "Pilih Kupon",
    "PLXD": "Pemesanan Batch",
    "FHJL": "Riwayat Pengiriman",
    "DDTJ": "Statistik Pesanan",
    "DDGL": "Manajemen Pesanan",
    "JKWFH": "Hanya Lihat yang Belum Dikirim",
    "DDS": "Jumlah Pesanan",
    "DGSPS": "Jumlah Produk Pemesanan",
    "THSPS": "Jumlah Produk Pengembalian",
    "YFHSPS": "Jumlah Produk yang Telah Dikirim",
    "WFHSPS": "Jumlah Produk yang Belum Dikirim",
    "YFHSPJE": "Jumlah Produk yang Telah Dikirim",
    "WFHSPJE": "Jumlah Produk yang Belum Dikirim",
    "WFH": "Belum Dikirim",
    "YGJ": "Perkiraan",
    "GGBM": "Kode Spesifikasi",
    "SLHJ": "Total Jumlah",
    "JEHJ": "Total Jumlah",
    "QPLKY": "Dapat Digunakan untuk Semua Kategori",
    "KYCXHDDJSY": "Dapat digunakan bersama dengan aktivitas promosi",
    "BKDKYF": "Tidak dapat dibayarkan untuk biaya pengiriman",
    "SYHBYTH": "Tidak akan dikembalikan setelah digunakan",
    "TiJi": "Volume",
    "ZhongLiang": "Berat",
    "ZongTiJi": "Total Volume",
    "ZongZhongLiang": "Total Berat",
    "QSRDHDCKDWLDHSJRSJH": "Mohon masukkan nomor pesanan/ nomor keluar gudang/ nomor resi logistik/ penerima/ nomor ponsel",
    "CKDH": "Nomor Keluar Gudang",
    "WLDZT": "Status Resi Logistik",
    "WLDH": "Nomor Resi Logistik",
    "SJR": "Penerima",
};
export default id_ID
